import { Edition } from '@atlassian/touchpoint-commons-event-analytics/types';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	// The primary CTA starts a Premium trial, which also makes useOnClickPrimaryCta close the dialog
	touchpointIntent: 'startTrial',
	dialogId: 'standard-storage-hard-limit-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.PREMIUM_EDITION,
};
